(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash/isUndefined"), require("lodash/isFunction"), require("lodash/has"));
	else if(typeof define === 'function' && define.amd)
		define(["lodash/isUndefined", "lodash/isFunction", "lodash/has"], factory);
	else if(typeof exports === 'object')
		exports["switchreducer"] = factory(require("lodash/isUndefined"), require("lodash/isFunction"), require("lodash/has"));
	else
		root["switchreducer"] = factory(root["lodash/isUndefined"], root["lodash/isFunction"], root["lodash/has"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition